import {
	array,
	boolean,
	intersect,
	nullable,
	number,
	partial,
	record,
	string,
	struct,
	union,
} from 'io-ts/Decoder';

import { AdditionalParameterValue } from '../../../../../whole-house/canvas/recipe/AdditionalParameterValue';
import { Id as FormulaUsageId } from '../../../../../whole-house/formula/usage/Id';
import { Id as MaterialTemplateUsageId } from '../../../../../whole-house/material-template/usage/Id';
import { Id as RecipeId } from '../../../../../whole-house/recipe/Id';

const MaterialRef = struct({
	materialTemplateUsageId: MaterialTemplateUsageId,
	formulaUsageId: FormulaUsageId,
});

export const Request = struct({
	canvasRecipe: intersect(
		struct({
			name: string,
			additionalParameterValues: array(AdditionalParameterValue),

			layers: array(
				intersect(
					struct({
						layerId: string,
						isDeduction: boolean,
					})
				)(
					partial({
						measurement: nullable(
							partial({
								height: number,
								pitch: number,
							})
						),
					})
				)
			),

			// One ref per ingredient, or a LIST of refs for multi-select ingredients —
			// allowed only for projection (list-returning) formulas; the client gates
			// on `projectionUtils.isProjectionIngredient`.
			ingredientsUsed: array(union(MaterialRef, array(MaterialRef))),
			referencedRecipeId: RecipeId,
		})
	)(
		partial({
			// Derived projected-lines visibility, keyed by ingredient name.
			projectedLayers: record(boolean),
		})
	),
});
